import { render, staticRenderFns } from "./Preset.vue?vue&type=template&id=c3f4b4fe&"
import script from "./Preset.vue?vue&type=script&lang=js&"
export * from "./Preset.vue?vue&type=script&lang=js&"
import style0 from "./Preset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports